import Style from "../Style.module.css"
import React, {useEffect, useState} from "react";
import {Form, OverlayTrigger, Tooltip} from "react-bootstrap";
import cabinetStyle from "./MentorCabinet.module.css";
import AvailableStylesSelector from "../AvailableStylesSelector";
import {EditPlayersListSetup} from "./EditPlayersListSetup";
import {useTranslation} from "react-i18next";

export function EditGroupGamesPage(props) {
    const prices = {
        0: 0,
        2: 5,
        3: 7,
        4: 9,
        5: 10,
        6: 11
    }

    const [playersReady, setPlayersReady] = useState(false)
    const { t } = useTranslation('translation', { keyPrefix: 'editGameModal' });

    function ResolveGameFieldStyle(event) {
        props.setSelectedStyle(event.target.value)
    }

    function ResolveSelectedDeck(event) {
        props.setSelectedDeck(event.target.value)
    }

    const renderVideoConnectionTooltip = (props) => (
        <Tooltip className={"alternativeVideoTooltip"} id="alternative-video-tooltip" {...props}>
            <div>{t('notEditable')}</div>
        </Tooltip>
    )

    function ResolveGameName(event) {
        const i = event.target.value
        props.setGamerName(i)
        if (!i) {
            props.setSaveDisabled(true)
        }

        if (i !== "" && playersReady) {
            props.setSaveDisabled(false)
        }
    }

    function resolvePrice() {
        if (props.freeTier) {
            return 0
        }
        else {
            let initialPlayersNum = props.initialPlayersNumber
            let currentPlayersNumber = props.players.filter(p => p.status !== 'deleted').length
            return prices[currentPlayersNumber] - prices[initialPlayersNum]
        }
    }

    useEffect(() => {
        let priceDelta = resolvePrice()
        props.setPriceDelta(priceDelta)
        if (props.gameName !== "" && playersReady && props.currentBalance >= priceDelta) {
            props.setSaveDisabled(false)
        } else {
            props.setSaveDisabled(true)
        }
    }, [playersReady, props.players.filter(p => p.status !== 'deleted').length])


    return (
        <div>
            <div>
                <div>
                    <Form>
                        <Form.Group className={cabinetStyle.profileElement}>
                            <Form.Label className={Style.bodyBaseText}>{t('gameName')} *</Form.Label>
                            <Form.Control
                                id={"game_name_id"}
                                style={{
                                    marginBottom: "24px"
                                }}
                                as="input"
                                defaultValue={props.gameName}
                                onChange={e => ResolveGameName(e)}
                            />
                                <Form.Label className={Style.bodyBaseText}>{t('video')}</Form.Label>
                                <OverlayTrigger placement="top-start" delay={{show: 150, hide: 250}}
                                                overlay={renderVideoConnectionTooltip}>
                                    <div>
                                        <Form>
                                            <Form.Check
                                                style={{
                                                    marginBottom: "24px",
                                                }}
                                                checked={props.videoAllowed}
                                                readOnly={true}
                                                id={"trial_game"}
                                                type="switch"
                                            />
                                        </Form>
                                    </div>
                                </OverlayTrigger>
                            <AvailableStylesSelector selectedStyle={props.selectedStyle}
                                                     setSelectedStyle={ResolveGameFieldStyle}
                                                     selectedDeck={props.selectedDeck}
                                                     setDefaultDeck={() => {
                                                     }}
                                                     setSelectedDeck={ResolveSelectedDeck}/>

                            <br/>
                        </Form.Group>
                    </Form>
                    <EditPlayersListSetup
                        setPlayersReady={setPlayersReady}
                        setPlayers={props.setPlayers}
                        existingPlayers={props.players}></EditPlayersListSetup>
                    <div style={{
                        display: "flex", justifyContent: "space-around",
                        alignContent: "center",
                        flexDirection: "column",
                        gap: "24px"
                    }}>
                    </div>
                </div>
            </div>
        </div>


    )
}
